/**
 * Kleines Symbol „Referenz“ (zwei Kettenglieder, PLAN.md §43): das Element steht als Referenz in dieser Episode, sein Original in einer
 * anderen. Ohne `title` nur Schmuck (der Text steht daneben).
 */
export function ReferenceIcon({ title, size = 12 }: { title?: string; size?: number }) {
  return (
    <svg
      className="ref-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true })}
      data-testid="reference-icon"
    >
      {title && <title>{title}</title>}
      <path d="M10 13.5a4.5 4.5 0 0 0 6.4.4l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.6 1.6" />
      <path d="M14 10.5a4.5 4.5 0 0 0-6.4-.4l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.6-1.6" />
    </svg>
  );
}
